"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWiringDiagramOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28 12V4h-8v3h-8.14A4 4 0 107 11.86V17h16v3.14A4 4 0 0020.14 23H12v-3H4v8h8v-3h8.14A4 4 0 1025 20.14V15H9v-3.14A4 4 0 0011.86 9H20v3zM10 26H6v-4h4zm16-2a2 2 0 11-2-2 2 2 0 012 2zM8 10a2 2 0 112-2 2 2 0 01-2 2zm14-4h4v4h-4z" })));
}
exports.default = SvgWiringDiagramOutline;
//# sourceMappingURL=WiringDiagramOutline.js.map